module.exports = "https://cdn-skillquest.mathletics.com/app/186/assets/fonts/19b29984d782b315838f127af8295dde.woff2";